import React, { useEffect, useState } from "react";
import {
  Paper,
  Table,
  TableCell,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Stack,
  Switch,
  IconButton,
  Tooltip,
  Box,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import CommonModal from "../../../components/common/Modal";
import TableSearch from "../../../components/common/Table/TableSearch";
import CommonButton from "../../../components/common/Button";
import Heading from "../../../components/Heading";
import { FaEdit, FaEye } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { UserDelete, UserList, UserStatusChange } from "../../../Service/user.service";
import { useDispatch } from "react-redux";
import { notificationSuccess } from "../../../state/Action/NotificationAction";
import Pagination from "../../../components/common/Table/Pagination";
import { FaArrowDown, FaArrowUp } from "react-icons/fa6";
import { RiLockPasswordFill } from "react-icons/ri";
import { ChnagePasswordOnMail } from "../../../Service/user.service";

const User_management = () => {
  const navigate = useNavigate();
  const [isModalOpen, setIsModalOpen] = useState({
    open: false,
    currentComponent: "",
  });


  const dispatch = useDispatch();
  const [userData, setUserData] = useState([]);
  const [search, setSearch] = useState('');
  const [totalData, setTotalData] = useState(0)
  const [openDrawer, setOpenDrawer] = React.useState(false);
  const [sortDate, setSortDate] = useState(false);
  const [shortKey, setShortKey] = useState('createdAt');
  const [sortBy, setSortBy] = useState(false);
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);
  const [totalPages, setTotalPages] = useState(0);

  const getUserList = async () => {
    setUserData([]);
    let query = `?search=${search}&page=${page + 1}&perPageSize=${rowsPerPage}&orderBy=${shortKey}&sortFlag=${sortBy}`;
    let res = await UserList(query);
    if (res?.status) {
      setUserData(res?.data);
      setTotalData(res?.total);
      setTotalPages(Math.ceil(res?.total / rowsPerPage));
    } else {
      setUserData(null);
      setTotalPages(0)
    }
  }

  const handleChangePage = (event, value) => {
    setPage(value - 1);
  };

  useEffect(() => {
    getUserList();
  }, [search, page, rowsPerPage, sortBy, shortKey]);


  const changeStatus = async () => {
    let res = isModalOpen && isModalOpen?.currentComponent == 'status'
      ? await UserStatusChange(isModalOpen?.id)
      : isModalOpen && isModalOpen?.currentComponent == "delete"
        ? await UserDelete(isModalOpen?.id)
        : isModalOpen && isModalOpen?.currentComponent == "changepassword"
          ? await ChnagePasswordOnMail(isModalOpen?.id) : null;

    if (res?.status) {
      dispatch(notificationSuccess({
        show: true,
        type: 'success',
        message: res.message || 'Success'
      }))
      getUserList();
      setIsModalOpen({ open: false, currentComponent: "", para: '', head: '', id: '' });
    } else {
      dispatch(notificationSuccess({
        show: true,
        type: 'error',
        message: 'Something went wrong. Please try again later.'
      }))
    }
  }

  const handleSortClick = (name, by) => {
    switch (name) {
      case 'createdAt':
        setSortBy(!by)
        setSortDate((current) => !current)
        setShortKey('createdAt')
        break;

      default:
        setSortBy(!sortDate)
        setSortDate(false)
        setShortKey('createdAt')
        break;
    }
  };
  return (

    <>
      <Stack gap={2}>
        <Heading head={"User Management"} />
        <Stack
          mb={1}
          flexDirection={"row"}
          justifyContent={"space-between"}
          alignItems={"center"} gap={'10px'}
        >
          <TableSearch search={search} setSearch={setSearch} setPage={setPage} />
          <Stack flexDirection={"row"} gap={1} alignItems={"center"}>
            <CommonButton
              buttonName={"Create"}
              size="small"
              onClick={() => navigate("/add-user", { state: { isEdit: false } })}
            />
          </Stack>
        </Stack>

        <TableContainer component={Paper}>
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>Name</TableCell>
                <TableCell>Email</TableCell>
                <TableCell onClick={() => handleSortClick('createdAt', sortDate)}>Created Date
                  {sortDate ? <FaArrowUp style={{ color: '#adadad' }} /> : <FaArrowDown style={{ color: '#adadad' }} />}
                </TableCell>
                <TableCell>Role</TableCell>
                <TableCell>Status</TableCell>
                <TableCell sx={{ textAlign: "end" }}>Action</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {userData && userData.map((data, index) => (
                <TableRow
                  key={index}
                  sx={{ "&:last-child td, &:last-child th": { border: 0 }, cursor: 'pointer' }}
                  onClick={() => setIsModalOpen({ open: true, currentComponent: "viewuser", id: data.id })}
                >
                  <TableCell>{data.firstName} {data.lastName}</TableCell>
                  <TableCell>{data.email}</TableCell>
                  <TableCell>{moment(data.createdAt).format("DD-MM-YYYY hh:mm A")}</TableCell>
                  <TableCell>{data.rolename}</TableCell>
                  <TableCell onClick={(e) => e.stopPropagation()}>
                    <Switch
                      checked={data?.status === 1 ? true : false}
                      onChange={(e) => {
                        setIsModalOpen({ id: data?.id, open: true, currentComponent: "status", head: "Change Status", para: "Are you sure you want to Change the Status?" })
                      }}
                    />
                  </TableCell>
                  <TableCell onClick={(e) => e.stopPropagation()}>
                    <Box
                      sx={{
                        display: "flex",
                        gap: 1,
                        justifyContent: "flex-end",
                      }}
                    >
                      <Tooltip title="Edit Details">
                        <IconButton
                          onClick={() => navigate("/add-user", { state: { id: data?.id, isEdit: true } })}
                          size="small"
                        >
                          <FaEdit />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Delete">
                        <IconButton size="small"
                          onClick={() => {
                            setIsModalOpen({
                              open: true,
                              currentComponent: "delete",
                              id: data.id,
                              head: "User Delete", para: "Are you sure you want to Delete the User?"
                            });
                          }}>
                          <MdDelete />
                        </IconButton>
                      </Tooltip>
                      <Tooltip title="Reset Password">
                        <IconButton
                          onClick={() =>
                            setIsModalOpen({
                              id: data.id,
                              open: true,
                              currentComponent: "changepassword",
                              head: "Change Password",
                              para: "Are you sure you want to Change Password of this Admin",
                            })
                          }
                          size="small"
                        >
                          <RiLockPasswordFill />
                        </IconButton>
                      </Tooltip>
                    </Box>
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </Stack>
      {userData !== null && (

        <Pagination
          totalData={totalData} // Total number of data items
          page={page} // Current page number
          setPage={setPage} // Function to update current page number
          rowsPerPage={rowsPerPage} // Number of rows per page
          setRowsPerPage={setRowsPerPage} // Function to update number of rows per page
        />)}
      <CommonModal
        modalOpen={isModalOpen}
        handelClick={changeStatus}
        handleClose={() => {
          setIsModalOpen({ open: false, currentComponent: "", id: "" });
          getUserList(); // Call the function after the modal is closed or an action is performed
        }}
      />
    </>
  )
}

export default User_management